import { render, staticRenderFns } from "./ArrowDownIcon.vue?vue&type=template&id=23b06999&"
import script from "./ArrowDownIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowDownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports